import { NgModule, RendererFactory2, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";

let LOADED = false;

@NgModule({
})
export class MaterialSupportModule {
    constructor(
        @Inject(DOCUMENT)
        doc : any,
        rendererFactory : RendererFactory2
    ) {
        if (typeof window !== 'undefined') {
            if (window['MATERIAL_THEME_LOADED']) {
                LOADED = true;
            }
        }

        if (!LOADED) {
            LOADED = true;
            if (typeof window !== 'undefined') {
                window['MATERIAL_THEME_LOADED'] = true;
            }
            
            console.log(`Loading material theme...`);
            let renderer = rendererFactory.createRenderer(doc, null);

            let link = renderer.createElement('link');

            renderer.setAttribute(link, 'rel', 'stylesheet');
            renderer.setAttribute(link, 'href', '/material-theme.css');
            renderer.appendChild(doc.head, link);

            let script = renderer.createElement('script');
            let scriptText = renderer.createText('window.MATERIAL_THEME_LOADED = true;');

            renderer.appendChild(script, scriptText);
            renderer.appendChild(doc.head, script);
        }
    }
}